import { ia } from 'lib/helpers/utility';

const isEstimated = ({ procedure, procedures }) => {
  const checkProcedure = (proc) => proc?.type === 'primary' && !('primary' in proc);

  if (typeof procedure === 'object' && procedure !== null) {
    return checkProcedure(procedure);
  }

  if (ia(procedures)) {
    return procedures.some(checkProcedure);
  }

  return false;
};

export default isEstimated;
